import { render, staticRenderFns } from "./EconomicCalendarCharts.vue?vue&type=template&id=1963748b&scoped=true"
import script from "./EconomicCalendarCharts.vue?vue&type=script&lang=js"
export * from "./EconomicCalendarCharts.vue?vue&type=script&lang=js"
import style0 from "./EconomicCalendarCharts.vue?vue&type=style&index=0&id=1963748b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963748b",
  null
  
)

export default component.exports